import { memo, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useRequestHook } from "utils/hooks/hooks";
import { addDocumentInRedux } from "utils/redux/actions";

const AutoLoadModal = (props) => {
  const {
    dispatch,
    docTypesList,
    toggleModal,
    serviceID,
    serviceType,
    displayReference,
    docId,
    status,
    signatureEditor,
    history,
  } = props;
  const { handleRequest } = useRequestHook();
  const getDocument = (docId, _status) => {
    return new Promise((resolve, reject) => {
      let currentStatus = status;
      if (_status) currentStatus = _status;

      handleRequest(
        "post",
        "/documents/load-selected-document",
        {
          documentId: docId,
          pagesToRequest: [0],
          serviceType,
          displayReference,
          docTypesList,
          approved: currentStatus === "0" ? false : true,
        },
        (response) => {
          if (currentStatus === "0" && !response) {
            return getDocument(docId, "1").then((response) => {
              const fallbackPath = `/documents/${serviceID}/1`;
              if (history?.location?.pathname !== fallbackPath) {
                history.push({
                  pathname: fallbackPath,
                  search: history?.location?.search,
                });
              }
              resolve(response);
            });
          } else if (currentStatus !== "0" && !response) {
            return;
          } else {
            resolve(response);
          }
        },
      );
    });
  };

  useEffect(() => {
    let isMounted = true;
    getDocument(docId).then((response) => {
      if (isMounted) {
        if (serviceType === "signature_envelopes" && signatureEditor) {
          window.location = `/esign-veditor/?id=${docId}&serviceid=${serviceID}`;
        } else {
          dispatch(addDocumentInRedux(response));
          toggleModal();
        }
      }
    });
    return () => {
      isMounted = false;
    };
  }, [docId]);

  return null;
};

/**
 * Take the id of saved in redux document and return it
 * in components props.
 */
const mapStateToProps = ({ savedDocument, docTypesList }) => ({
  savedDocument,
  docTypesList,
});

export default withRouter(connect(mapStateToProps)(memo(AutoLoadModal)));
